import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { TextAlpha } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetProductFulfillment, makeGetProductFulfillmentBySize, } from '../../../redux/product/selectors/ProductSelector';
export const ProductFulfillment = () => {
    const { checkoutCc: clickAndCollectEnabled } = useAemConfig();
    const { hdExcluded, ccExcluded, fulfillmentCopyDescription } = useSelector(makeGetProductFulfillment());
    const fulfillmentBySize = useSelector(makeGetProductFulfillmentBySize());
    const availableInStoreOnly = ccExcluded && (hdExcluded || (fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded));
    const availableOnlineOnly = ccExcluded && !hdExcluded && !(fulfillmentBySize === null || fulfillmentBySize === void 0 ? void 0 : fulfillmentBySize.storeSourceExcluded);
    const shouldShowFulfillmentInfo = (clickAndCollectEnabled && availableInStoreOnly) || availableOnlineOnly;
    if (!shouldShowFulfillmentInfo || !fulfillmentCopyDescription) {
        return null;
    }
    return (_jsx(TextAlpha, { testId: availableOnlineOnly ? 'check_stock_title' : undefined, children: fulfillmentCopyDescription }));
};
